import type { IconData } from '@stacksjs/iconify-core'

export const bombSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M37.896 12.031a4.5 4.5 0 0 1 5.829-1.048l.503.303a1.5 1.5 0 0 0 1.544-2.573l-.504-.302a7.5 7.5 0 0 0-9.715 1.746l-.113.142q-.661-.566-1.255-.992c-2.471-1.78-5.41-.805-7.183.967l-.428.428A18.5 18.5 0 0 0 20 9.5C9.783 9.5 1.5 17.782 1.5 28S9.783 46.5 20 46.5S38.5 38.217 38.5 28c0-2.316-.425-4.532-1.202-6.575l.428-.428c1.771-1.772 2.746-4.712.967-7.182a19 19 0 0 0-1.111-1.392zM7.5 28a1.5 1.5 0 0 0 3 0a9.5 9.5 0 0 1 9.5-9.5a1.5 1.5 0 0 0 0-3c-6.904 0-12.5 5.596-12.5 12.5\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default bombSolid
